// src/sources/jurisdictions.ts
//
// Static jurisdiction metadata for icon display.
// Identifiers and domains come from config (ENV/YAML).
// Display names come from i18n keys: web.regions.jurisdictions.{id}.name

/**
 * Icon configuration for jurisdiction display.
 * Matches JurisdictionIcon type from schemas/contracts/config/section/jurisdiction.ts
 */
export interface JurisdictionIconConfig {
  collection: string;
  name: string;
}

/**
 * Default icon definitions for known jurisdiction identifiers.
 * Used when jurisdiction config doesn't include icon data.
 */
// One unified globe across every jurisdiction — a mix of per-region earth icons
// (earth-europe / earth-americas / …) looked inconsistent in the region toggle.
export const JURISDICTION_ICONS: Record<string, JurisdictionIconConfig> = {
  EU: { collection: 'fa6-solid', name: 'globe' },
  US: { collection: 'fa6-solid', name: 'globe' },
  CA: { collection: 'fa6-solid', name: 'globe' },
  UK: { collection: 'fa6-solid', name: 'globe' },
  NZ: { collection: 'fa6-solid', name: 'globe' },
  AT: { collection: 'fa6-solid', name: 'globe' },
  APAC: { collection: 'fa6-solid', name: 'globe' },
};

export const DEFAULT_JURISDICTION_ICON: JurisdictionIconConfig = {
  collection: 'fa6-solid',
  name: 'globe',
};

/**
 * Get the icon for a jurisdiction identifier.
 * Falls back to default globe icon if no mapping exists.
 */
export function getJurisdictionIcon(identifier: string): JurisdictionIconConfig {
  return JURISDICTION_ICONS[identifier.toUpperCase()] ?? DEFAULT_JURISDICTION_ICON;
}
